import React, { useState, useRef, useCallback, useEffect } from "react";

export interface UseAccessibleCardReturnValue {
  isFocused: boolean;
  handleClick: (e: React.MouseEvent) => void;
  cardRef: React.RefObject<HTMLDivElement>;
}

export const useAccessibleCard = (): UseAccessibleCardReturnValue => {
  const [isFocused, setIsFocused] = useState(false);
  const cardRef = useRef<HTMLDivElement>(null);

  const getChildAnchorEl = useCallback(() => {
    return cardRef.current?.querySelector("a");
  }, []);

  const handleClick = useCallback(
    (_e: React.SyntheticEvent): void => {
      if (!cardRef.current) return;
      const cardLink = getChildAnchorEl();
      cardLink?.click();
    },
    [getChildAnchorEl]
  );

  useEffect(() => {
    if (!cardRef.current) {
      return;
    }

    const cardLink = getChildAnchorEl();

    if (cardLink) {
      cardLink.addEventListener("focus", () => {
        setIsFocused(true);
      });
      cardLink.addEventListener("blur", () => {
        setIsFocused(false);
      });
    }
  }, [getChildAnchorEl]);

  return { isFocused, handleClick, cardRef };
};
